import { ABlank } from "../ABlank/ABlank"
import * as React from "react"
import { AnalyticsEventsEnum, sendEvent } from "../../../utils/analytics"
import { TestIds } from "../../../../e2e/data"

export type KBLinkProp = keyof typeof kbLinks

type Props = {
    link: KBLinkProp
}

export const KBLink = (props: Props) => {
    const data = kbLinks[props.link]
    if (!data) {
        return null
    }

    return (
        <ABlank
            href={data.link}
            onClick={() => {
                sendEvent(AnalyticsEventsEnum.KBLinkClicked, {
                    key: props.link,
                    link: data.link,
                    label: data.label,
                })
            }}
            className={classes.link}
            data-testid={TestIds.kbLink}>
            {data.label}
        </ABlank>
    )
}

export const kbLinks = {
    itemsAndCats: {
        label: "Learn more about Menu Management",
        link: "https://figure.dev/support/items-categories",
    },
    options: {
        label: "Learn more about Options",
        link: "https://figure.dev/support/options-and-modifiers",
    },
    modifiers: {
        label: "Learn more about Modifiers",
        link: "https://figure.dev/support/options-and-modifiers",
    },
    modGroups: {
        label: "Learn more about Modifier Groups",
        link: "https://figure.dev/support/options-and-modifiers",
    },
    timesheets: {
        label: "Learn more about Timesheets",
        link: "https://figure.dev/support/timesheets",
    },
    assignments: {
        label: "Learn more about Assignments",
        link: "https://figure.dev/support/table-layout-management",
    },
    locAndServices: {
        label: "Learn more about Locations & Services",
        link: "https://figure.dev/support/manage-locations-services",
    },
    inventory: {
        label: "Learn more about Inventory",
        link: "https://figure.dev/support/inventory-management",
    },
    loyalty: {
        label: "Learn more about Loyalty Program",
        link: "https://figure.dev/support/loyalty-program",
    },
    cardPrograms: {
        label: "Learn more about Card Programs",
        link: "https://figure.dev/support/gift-cards",
    },
    employees: {
        label: "Learn more about Employee Management",
        link: "https://figure.dev/support/employee-agenda",
    },
    positions: {
        label: "Learn more about Positions",
        link: "https://figure.dev/support/employee-agenda#positions",
    },
    rolesAccess: {
        label: "Learn more about Roles & Access",
        link: "https://figure.dev/support/employee-agenda#roles",
    },
    pricings: {
        label: "Learn more about ± Pricings",
        link: "https://figure.dev/support/special-pricing",
    },
    promotions: {
        label: "Learn more about Promotions",
        link: "https://figure.dev/support/promotions-%E2%80%93-coupons",
    },
    taxation: {
        label: "Learn more about Taxation",
        link: "https://figure.dev/support/taxation",
    },
    salesInputPos: {
        label: "Learn more",
        link: "https://figure.dev/support/add-items-to-pos",
    },
    salesInputMib: {
        label: "Learn more",
        link: "https://figure.dev/support/add-items-to-make-it-butter-website",
    },
    salesInputKiosk: {
        label: "Learn more",
        link: "https://figure.dev/support/add-items-to-kiosk",
    },
}

const classes = {
    link: "text-13 font-normal text-primary-color underline",
}
